import type { AxiosError } from 'axios';

/**
 * Extract a human-readable error message from an Axios error response.
 * Handles NestJS ValidationPipe array messages, single string messages,
 * and falls back to the provided fallback string.
 */
export function extractApiError(err: unknown, fallback = 'An unexpected error occurred'): string {
  const e = err as AxiosError<{ message?: string | string[]; error?: string }>;
  const msg = e?.response?.data?.message;
  if (Array.isArray(msg)) return msg.join('. ');
  if (typeof msg === 'string' && msg.trim().length > 0) return msg;
  return fallback;
}
